//
// MeasureSortItem.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "../DataItem";
import "@sas-dvr/ltjs-commons/models/data/sorting/SortDirection";
import "../common/SortMember";

var MeasureSortItem = createModule("BIRD::MeasureSortItem", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        dataItem: 1,
        sortDirection: 4,
        sortMembers: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default MeasureSortItem;
